import { MEDIA_DETAILS, LIKE_FEED_LIST, LIKE_FEED, COMMENT_FEED_LIST, COMMENT_FEED, LIKE_COMMENT, LIKE_COMMENT_LIST, ALBUM_DETAILS, LAST_ALBUM} from './constants';
import { getPublicIP, getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader, pageloader} from './utils';

export const mediaDetails = (mediaDetails) => {
    return {
      type: MEDIA_DETAILS,
      mediaDetails
    };  
};
export const likeFeedList = (likeFeedList) => {
  return {
    type: LIKE_FEED_LIST,
    likeFeedList
  }; 
};
export const likeFeedResponse = (likeFeedResponse) => {
  return {
    type: LIKE_FEED,
    likeFeedResponse
  }; 
};
export const commentFeedList = (commentFeedList) => {
  return {
    type: COMMENT_FEED_LIST,
    commentFeedList
  }; 
};
export const commentFeedResponse = (commentFeedResponse) => {
  return {
    type: COMMENT_FEED,
    commentFeedResponse
  }; 
};
export const likeCommentResponse = (likeCommentResponse) => {
  return {
    type: LIKE_COMMENT,
    likeCommentResponse
  }; 
};
export const likeCommentList = (likeCommentList) => {
  return {
    type: LIKE_COMMENT_LIST,
    likeCommentList
  }; 
};
export const userAlbumDetails = (albumDetails) => {
  return {
    type: ALBUM_DETAILS,
    albumDetails
  }; 
};
export const createAlbumRes = (newAlbum) => {
  return {
    type: LAST_ALBUM,
    newAlbum,
  }; 
};


export const fetchMediadetails = (params) => {
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      bodyFormData.set('image_id', params.imageId);
      const headers = getAuthHeader();
      loader(true);
      postReq(`${apiURLPrefix}/usergallery/full_image_details`, bodyFormData , headers)
      .then(handleResponse) 
      .then((res) => {
        dispatch(mediaDetails(res));
      }).catch((err)=>{
        console.log(err);
      }) 
    }
}

export const fetchLikeGallery = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('image_id', params.image_id);
    bodyFormData.set('return_type', params.return_type);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/image_reaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(likeFeedList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const updateLikeGallery = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', params.user_id);
    bodyFormData.set('image_id', params.image_id);
    bodyFormData.set('reaction', params.reaction);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/gallery_image_like`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(likeFeedResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};


export const fetchCommentMedia = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('image_id', params.image_id);
    bodyFormData.set('return_type', params.return_type);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/image_reaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      res.comment_id = params.comment_id;
      res.section    = params.section;
      dispatch(commentFeedList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const updateCommentMedia = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('image_id', params.image_id);
    if(params.parent_comment_id != null){
      bodyFormData.set('parent_comment_id', params.parent_comment_id);
    }
    /*bodyFormData.set('image', params.image);
    bodyFormData.set('image_type', params.image_type);*/
    bodyFormData.set('comment', params.comment);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/image_comment`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(commentFeedResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const updateLikeMediaComment = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('image_id', params.feed_id);
    bodyFormData.set('reaction', params.reaction);
    bodyFormData.set('comment_id', params.comment_id);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/image_commentlike`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      res.comment_id = params.comment_id;
      res.section    = params.section;
      dispatch(likeCommentResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const fetchLikeMediaComment = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('comment_id', params.comment_id);
    bodyFormData.set('loggedin_user_id', 6);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/usergallery/image_commentreaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      res.comment_id = params.comment_id;
      res.section    = params.section;
      dispatch(likeCommentList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const fetchAlbumDetails = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('album_id', params.album_id);
    bodyFormData.set('is_web', 1);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/fetch_album`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(userAlbumDetails(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};


export const createAlbum = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('album_title', params.post_content);
    bodyFormData.set('media_files', JSON.stringify(params.media_files));
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/create_album`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(createAlbumRes(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};

export const editAlbumRequest = (params) => {
  
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('album_id',  params.album_id);
    bodyFormData.set('album_title', params.album_title);
    bodyFormData.set('media_files', JSON.stringify(params.media_files));
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/userprofile/edit_web_album`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(createAlbumRes(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }  
};

